module.exports = __webpack_public_path__ + "img/1585018403.7002dbe3.jpg";